// src/components/LoadingSpinner.js
import React from 'react';
import '../styles/LoadingSpinner.css'

const LoadingSpinner = ({ small }) => {
  return (
    <div className={`loading-spinner-overlay ${small ? 'small' : ''}`}>
      <div className="loading-spinner">
        <div className="spinner"></div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
